import { PersistConfig } from 'redux-persist';

export enum PersistedStateKeys {
  location = 'location',
  cart = 'cart',
  prices = 'prices',
  checkout = 'checkout',
  credit = 'credit',
  auth = 'auth'
}

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export type PersistedConfigs = Record<PersistedStateKeys, PersistConfig<any>>;
